<template>
  <div class="superuser-search-result">
    <div v-if="mq('medium')" class="superuser-search-result__head">
      <div class="superuser-search-result__cell">
        {{ t('superuserSearchCustomerNumber') }}
      </div>

      <div class="superuser-search-result__cell">
        {{ t('superuserSearchCustomerName') }} / {{ t('superuserSearchCustomerEmail') }}
      </div>

      <div class="superuser-search-result__cell">
        {{ t('superuserSearchCustomerAddress') }}
      </div>

      <div class="superuser-search-result__cell">
        {{ t('superuserSearchPhoneNumber') }}
      </div>

      <div class="superuser-search-result__cell">
        {{ t('superuserSearchCustomerCreditLimit') }}
      </div>

      <div class="superuser-search-result__cell">
        {{ t('superuserSearchCustomerEod') }}
      </div>

      <!--
      <div class="superuser-search-result__cell">
        {{ tStatic('alias') }}
      </div>
      -->
    </div>

    <template v-if="rows === null">
      <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
        {{ t('superuserSearchDoSearchPhrase') }}
      </div>
    </template>

    <template v-else-if="rows && rows.length === 0">
      <div class="superuser-search-result__body-row superuser-search-result__body-row--message">
        {{ t('superuserSearchNoHits') }}
      </div>
    </template>

    <template v-else>
      <div
        v-for="(row, i) in rows"
        :key="row.id"
        v-element-loader="{ endpoint: 'superuser/synccustomer/' + row.id }"
        :data-pw="`superuser-search-result-${row.userName}`"
        :class="'superuser-search-result__body-row ' + ((row.removed || row.isSoftDeleted)
          ? 'superuser-search-result__body-row_removed'
          : row.isDisabled
            ? 'superuser-search-result__body-row_disabled'
            : '')">
        <div class="superuser-search-result__cell">
          <div v-if="mq('to-medium')">
            <a href="#" :title="t('superuserSearchGoToErpButtonLabel')" @click="openErp(row)">
              {{ t('superuserSearchCustomerNumber') }}
            </a>
            <br>
            <a
              v-if="row.numberOfUsers > 1"
              href="#"
              :title="t('superuserSearchUserLabel') + '\n\n' + row.users.map(user => `${user.name} (${user.userName}) ${user.isUserAdmin ? 'ADMIN' : ''}`).join('\n')"
              @click="searchCustomerNumber(row)">
              {{ `(${row.numberOfUsers})` }}
            </a>
          </div>
          <a href="#" :title="t('superuserSearchGoToErpButtonLabel')" @click="openErp(row)">
            {{ row.customerNumber }}
          </a>
          <a
            v-if="row.numberOfUsers > 1"
            href="#"
            :title="t('superuserSearchUserLabel') + '\n\n' + row.users.map(user => `${user.name} (${user.userName}) ${user.isUserAdmin ? 'ADMIN' : ''}`).join('\n')"
            @click="searchCustomerNumber(row)">
            {{ `(${row.numberOfUsers})` }}
          </a>
        </div>

        <div class="superuser-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserSearchCustomerName') }} / {{ t('superuserSearchCustomerEmail') }}
          </div>

          <div class="superuser-search-result__cell-bolder">
            {{ row.name }}
            <div v-if="userAccountName(row)">
              {{ userAccountName(row) }}
            </div>
          </div>

          <template v-if="mq('to-medium')">
            -
          </template> {{ row.userEmail }}
          <div v-if="row.alias">
            {{ row.alias }}
          </div>
        </div>

        <div class="superuser-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserSearchCustomerAddress') }}
          </div>

          <div v-if="row.invoiceAddress">
            <template v-if="row.invoiceAddress.addressCo">
              {{ row.invoiceAddress.addressCo }}
              <br>
            </template>
            {{ row.invoiceAddress.addressLine1 }}<br>
            {{ row.invoiceAddress.postalCode }} {{ row.invoiceAddress.city }}<br>
            {{ row.invoiceAddress.countryName }}
          </div>
        </div>

        <div class="superuser-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserSearchPhoneNumber') }}
          </div>

          {{ row.phone }}<br>
          {{ row.userPhone }}
        </div>

        <div class="superuser-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserSearchCustomerCreditLimit') }}
          </div>

          {{ row.creditAmountLeftLCY }}
          <div v-if="row.invoicedBlocked" style="color: red">
            {{ t('superuserSearchCustomerInvoicedBlocked') }}
          </div>
          <div v-if="row.isKlarnaBlocked" style="color: red; font-weight: 600">
            {{ t('superuserSearchCustomerIsKlarnaBlocked') }}
          </div>
        </div>

        <div class="superuser-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserSearchCustomerEod') }}
          </div>

          {{ row.customerEOD }}
        </div>

        <!--
        <div class="superuser-search-result__cell">
          <div v-if="mq('to-medium')">
            {{ tStatic('alias') }}
          </div>

          {{ row.alias }}
        </div>
        -->

        <div v-if="!row.removed && !row.isSoftDeleted" class="superuser-search-result__cell superuser-search-result__cell--actions">
          <oie-base-button
            v-element-loader="{ endpoint: 'superuser/impersonateUser' }"
            css-classes="superuser-search-results__action button--gray"
            :data-pw="`superuser-impersonate-${row.userId}`"
            :text="row.isDisabled ? t('superuserSearchInactivatedUserLabel') : t('superuserSearchSignInAsUserButtonLabel')"
            :disabled="row.isDisabled"
            @click="impersonateUser(row.userId)"></oie-base-button>
          <!-- <div v-else class="superuser-search-results__action--disabled">
      Inaktiverad
    </div> -->

          <oie-base-button
            v-element-loader="{ endpoint: 'superuser/impersonateUser/' + row.id }"
            css-classes="superuser-search-results__action button--gray"
            :text="t('superuserSearchEditUserButtonLabel')"
            @click="openEditUserView(row, i)"></oie-base-button>

          <oie-base-button
            css-classes="superuser-search-results__action button--gray"
            :text="t('superUserSyncCustomerButtonText')"
            :disabled="userIsSyncing"
            @click="syncCustomer(row.userId, row.id, i)"></oie-base-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import httpService from '@/core/http-service'

export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    userIsSyncing: false
  }),
  methods: {
    userAccountName(row) {
      const name = (row.name || '').replace(/\s+/g, '')
      const fullName = (row.fullName || '').replace(/\s+/g, '')
      return row.isMultiUser || name !== fullName ? row.fullName : null
    },
    async impersonateUser(userId) {
      await this.$store.dispatch('myMachines/setGlobalMyMachinesSelection', {})
      try {
        const { data } = await httpService.post('superuser/impersonate', {
          userId: userId
        })
        window.location = data.redirectUrl
      } catch(error) {
        console.error('failed impersonate user', error)
      }
    },
    openEditUserView(user, index) {
      this.publish('superuser-edit-user-data', { user, index })
    },
    openErp(user) {
      window.open(this.t('superuserSearchGoToErpUrl').replace('customerNumber', user.customerNumber))
    },
    searchCustomerNumber(user) {
      this.publish('superuser-search-customer-number', user.customerNumber)
    },
    syncCustomer(userId, rowId, rowIndex) {
      this.userIsSyncing = true
      httpService.post('superuser/synccustomer/' + rowId, { userId: userId }).then((response) => {
        if(response.data && response.data.success && response.data.customer) {
          this.publish('superuser-user-updated', { user: response.data.customer, index: rowIndex })
        }
      }).finally(() => {
        this.userIsSyncing = false
      })
    }
  }
}
</script>

<style lang="scss">
.superuser-search-result {
  @include body-smaller;
  background-color: color(background-white);
  border: 1px solid color(border-gray);
}

.superuser-search-result > div:not(:last-child) {
  border-bottom: 1px solid color(border-gray);
}

.superuser-search-result__head {
  display: flex;
  background-color: color(background-blue-6);
  padding-right: measure(quarter);
  padding-left: measure(quarter);
}

.superuser-search-result__body-row {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  padding-right: measure(quarter);
  padding-left: measure(quarter);

  @include media(small) {
    flex-direction: row;
  }

  @include media(medium) {
    flex-wrap: nowrap;
  }
}

.superuser-search-result__body-row_removed {
  text-decoration: line-through;
}

.superuser-search-result__body-row--message {
  justify-content: center;
  min-height: 3rem;
  padding: measure(quarter);
  font-style: italic;
}

.superuser-search-result__cell {
  flex-shrink: 0;
  padding: measure(quarter);

  @include media(to-small) {
    width: 100%;
  }

   &:nth-child(1) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 7%;
    }
  }

   &:nth-child(2) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 22%;
      word-break: break-all;
    }
  }

   &:nth-child(3) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 22%;
    }
  }

   &:nth-child(4) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 10%;
    }
  }

  &:nth-child(5) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: 7%;
    }
  }

   &:nth-child(6) {
    @include media(small) {
      width: 50%;
    }

    @include media(medium) {
      width: auto;
      flex-grow: 1;
    }
  }
}

.superuser-search-result--product-result .superuser-search-result__cell:nth-child(1) {
  @include media(medium) {
    width: 25%;
  }
}

.superuser-search-result__head > .superuser-search-result__cell,
.superuser-search-result__cell > div:first-child {
  @include body-smaller-semi-bold;
}

.superuser-search-result__cell-bolder {
  @include body-smaller;

  @include media(medium) {
    @include body-smaller-semi-bold;
  }
}

.superuser-search-result__cell--actions {
  display: flex;
  flex-direction: column;

  @include media(small) {
    flex-direction: row;
    align-self: center;
  }
}

.superuser-search-results__action {
  @include body-smaller;
  width: auto;
  height: 2.875rem;

  &:first-child,
  &:nth-child(2) {
    margin-bottom: measure(quarter);

    @include media(small) {
      margin-right: measure(quarter);
      margin-bottom: 0;
    }
  }
}

.superuser-search-results__action--disabled {
  color: color(text-gray);
}
</style>
